export default class ViewTextFieldVO
{

	// ----------------------------------
	//	Properties
	// ----------------------------------

	defaultValue = '';
	name = "Textfield";
	fieldType = 'textField';
	uiComponent = 'view-text-field';
	description = 'A simple text field.';

	constructor()
	{
		
	}
}